import styled from 'styled-components';
import {device} from '../../styled/device';

export const WrapperWithButton = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 50px;

  @media (max-width: ${device.tablet}) {
    margin-left: 0;
  }
`;

export const PleaseSignModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  max-width: 400px;
  height: 400px;

  .title {
    font-size: 24px;
  }

  .text {
    font-size: 18px;
  }
`;

export const SuperhogTerms = styled.div`
  margin-top: 10px;
`;
